var version = '0.1814';
var date = '11/27/2025, 09:39:09';
var verData = '发布日期:　' + date + '\n版本:　' + version + 'PC';
export default verData;
// 云呼叫平台代码
// export const version = '个宽弹屏' + 3.7;